import { SupportedLocalizedDateTimeFormat } from './SupportedLocalizedDateTimeFormat';
var getDateFormatOptionsMap = function () {
    var dateFormatOptionsMap = new Map();
    dateFormatOptionsMap.set(SupportedLocalizedDateTimeFormat.Medium, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
    dateFormatOptionsMap.set(SupportedLocalizedDateTimeFormat.Long, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
    });
    dateFormatOptionsMap.set(SupportedLocalizedDateTimeFormat.WeekdayDate, {
        day: 'numeric',
        weekday: 'short',
    });
    dateFormatOptionsMap.set(SupportedLocalizedDateTimeFormat.WeekdayDateLong, {
        day: 'numeric',
        weekday: 'long',
    });
    dateFormatOptionsMap.set(SupportedLocalizedDateTimeFormat.MonthDate, {
        month: 'short',
        day: 'numeric',
    });
    dateFormatOptionsMap.set(SupportedLocalizedDateTimeFormat.Weekday, {
        weekday: 'short',
    });
    dateFormatOptionsMap.set(SupportedLocalizedDateTimeFormat.Time, {
        hour: 'numeric',
        minute: 'numeric',
    });
    return dateFormatOptionsMap;
};
/**
 * This Map is used to drive Intl.DateTime formats and Date.toLocaleDateString(...) if Intl is unsupported.
 */
export var dateFormatOptionsMap = getDateFormatOptionsMap();
//# sourceMappingURL=dateFormatOptions.js.map